import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Scale, Languages } from "lucide-react";
import { TopBar, Nav } from "../components/Sections";
import { Footer } from "../components/ContactFooter";
import { LEGAL_LINKS, COMPANY } from "../legal/links";

const setMeta = (title, description) => {
  document.title = title;
  const m = document.querySelector('meta[name="description"]');
  if (m && description) m.setAttribute("content", description);
};

export default function LegalPage({ doc }) {
  useEffect(() => {
    window.scrollTo(0, 0);
    setMeta(doc.seoTitle, doc.description);
  }, [doc.seoTitle, doc.description]);

  return (
    <div className="min-h-screen bg-white" data-testid={`legal-page-${doc.slug}`}>
      <TopBar />
      <Nav />
      <main>
        <section className="navy-gradient-soft grain text-white relative overflow-hidden">
          <div className="tricolor-bar absolute top-0 left-0 right-0" />
          <div className="container-x py-14 md:py-20">
            <Link to="/" className="inline-flex items-center gap-2 text-white/75 hover:text-[#FF8C42] text-[13px] font-semibold transition-colors" data-testid="legal-back-home">
              <ArrowLeft size={14} /> Back to home
            </Link>
            <span className="eyebrow eyebrow-on-navy mt-6"><Scale size={12} /> Legal information</span>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-5 leading-[1.05]" data-testid="legal-title">{doc.title}</h1>
            <p className="mt-4 text-white/70 text-sm">{COMPANY.name} · Company Number {COMPANY.number} · {COMPANY.jurisdiction} · Last updated {COMPANY.updated}</p>
          </div>
        </section>

        <section className="section">
          <div className="container-x grid lg:grid-cols-12 gap-10">
            <aside className="lg:col-span-3">
              <div className="soft-card p-5 lg:sticky lg:top-24">
                <div className="text-[11px] font-bold tracking-[0.16em] uppercase text-[#4A4A4A]">Policies</div>
                <ul className="mt-3 space-y-2 text-[14px]">
                  {LEGAL_LINKS.map((l) => (
                    <li key={l.to}>
                      <Link to={l.to} className={`hover:text-[#F37021] transition-colors ${l.to === `/${doc.slug}` ? "text-[#F37021] font-bold" : "text-[#002B7F] font-semibold"}`} data-testid={`legal-nav-${l.to.slice(1)}`}>
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </aside>

            <article className="lg:col-span-9 legal-prose" data-testid="legal-content">
              <p className="lead">{doc.intro}</p>
              {doc.summaryRo && (
                <div className="legal-summary-ro" data-testid="legal-summary-ro">
                  <div className="flex items-center gap-2 font-display text-[20px] text-[#002B7F]">
                    <Languages size={18} className="text-[#F37021]" /> {doc.summaryRo.title}
                  </div>
                  <p className="!mt-1 text-[12.5px] text-[#6B7280]">Rezumat informativ. Versiunea completă în limba engleză de mai jos este cea care se aplică.</p>
                  <ul>{doc.summaryRo.items.map((t) => <li key={t.slice(0, 60)}>{t}</li>)}</ul>
                </div>
              )}
              {doc.sections.map((s) => (
                <section key={s.h}>
                  <h2>{s.h}</h2>
                  {s.p?.map((t) => <p key={t.slice(0, 60)}>{t}</p>)}
                  {s.list && <ul>{s.list.map((t) => <li key={t.slice(0, 60)}>{t}</li>)}</ul>}
                </section>
              ))}
            </article>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
